import {format} from 'date-fns'
import {toZonedTime} from 'date-fns-tz'

export default class SiteUtil {
    static getPictureUrl(item, config) {
        const pictureUrl = typeof item === 'string' ? item : item?.pictureUrl
        if (!pictureUrl) return null
        if (pictureUrl.startsWith('http')) {
            return pictureUrl;
        } else {
            return config.public.dripMediaServer + pictureUrl;
        }
    }

    static appendDateToUrl(url) {
        url = url?.value || url || ''
        const separator = url?.includes('?') ? '&' : '?'
        const dateParam = `dt=${encodeURIComponent(new Date().toISOString())}`
        return `${url.value || url}${separator}${dateParam}`
    }

    static extractAddressComponents(addressComponents) {
        const componentTypes = {
            // eslint-disable-next-line camelcase
            street_number: "short_name",
            route: "long_name",
            locality: "long_name", // City
            // eslint-disable-next-line camelcase
            administrative_area_level_1: "short_name", // State
            country: "long_name",
            // eslint-disable-next-line camelcase
            postal_code: "short_name",
        }

        const extracted = {}

        addressComponents.forEach(component => {
            component.types.forEach(type => {
                if (componentTypes[type]) {
                    extracted[type] = component[componentTypes[type]]
                }
            })
        })

        return extracted
    }

    static formatDate(utcDate, tz) {
        const utcDateTime = toZonedTime(utcDate, tz)

        // Return the formatted date
        return format(utcDateTime, 'yyyy-MM-dd')

    }

    static formatCurrency(val) {
        return '$ ' + Number(val).toFixed(2)

    }

    static clientTZ() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone
    }

    static resolveUserStatusVariant = stat => {
        const statLowerCase = stat.toLowerCase()
        if (statLowerCase === 'suspended')
            return 'warning'
        if (statLowerCase === 'active')
            return 'success'

        return 'primary'
    }

    static deepMerge = (target, source) => {
        if (typeof target !== 'object' || target === null) return
        if (typeof source !== 'object' || source === null) return

        for (const key of Object.keys(source)) {
            const srcVal = source[key]
            const tgtVal = target[key]

            if (
                    typeof srcVal === 'object' &&
                    srcVal !== null &&
                    !Array.isArray(srcVal)
            ) {
                if (!tgtVal || typeof tgtVal !== 'object') {
                    target[key] = {} // Create nested object if missing
                }
                SiteUtil.deepMerge(target[key], srcVal) // Recurse
            } else if (Array.isArray(srcVal)) {
                target[key] = [...srcVal] // Shallow replace array (or customize)
            } else {
                target[key] = srcVal // Overwrite primitive or null
            }
        }
    }

    // Coerce a redirect target to a same-origin relative path; reject anything
    // that could escape the current origin. Open-redirect happens when login
    // pages blindly follow `?redirectTo=https://evil.example/` after auth —
    // the user trusts the host bar still showing our domain right up until
    // the redirect fires. Whitelist: must start with a single `/`, must not
    // be protocol-relative (`//host`) or backslash-tricked (`/\host`), must
    // not contain whitespace or control chars (header-injection vectors).
    static safeInternalRedirect = (target, fallback = null) => {
        if (typeof target !== 'string') return fallback
        if (target.length === 0 || target.length > 2048) return fallback
        if (/[\s\x00-\x1F\x7F]/.test(target)) return fallback
        if (target[0] !== '/') return fallback
        if (target[1] === '/' || target[1] === '\\') return fallback
        return target
    }

    static getCountryCode = (countryName) => {
        if (!countryName) return 'AU'
        const cn = countryName.toLowerCase().replace(/ /g, '')
        if (cn.includes('zealand')) return 'NZ'
        if (cn.includes('australia')) return 'AU'
        return 'AU'
    }

}
